import { A01, A01Output } from 'api/U012';
import { useEffect, useState } from 'react';

export function useGetInquiryInfo(
  userId: string
): [A01Output | undefined, boolean, Error | null, () => void] {
  const [loading, setLoading] = useState<boolean>(true);
  const [inquiryInfo, setInquiryInfo] = useState<A01Output>();
  const [err, setError] = useState<Error | null>(null);

  const [refreshCount, setRefreshCount] = useState<number>(0);
  const refresh = () => setRefreshCount(refreshCount + 1);

  const fetchInquiryInfo = async (user_id: string, cancellation: AbortSignal) => {
    return await A01({ user_id }, cancellation);
  };

  useEffect(() => {
    if (!userId) {
      return;
    }
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const inquiryInfo = await fetchInquiryInfo(userId, cancellation);
        setInquiryInfo(inquiryInfo);
      } catch (err) {
        console.error(err);
        setInquiryInfo(undefined);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, [userId, refreshCount]);

  return [inquiryInfo, loading, err, refresh];
}
